export const prepareSubmitData = (pppId: string) => ({
	body: {
		kodPodani: 'PPP_UKONCENI',
		pppId,
	},
});
